import React from "react";
import { formatTimeHHmm, toZonedDateTime } from "utils/time-utils";
import { useDisplayTimezone } from "hooks/useTimezone";
import { T } from "services/lang/LanguageService";
import { FormEvent } from "primereact/ts-helpers";
import { Calendar } from "primereact/calendar";
import { strTimeAsNativeDate } from "./Time";

export type Item = {
  id: string;
  value: string;
};

interface TimeValueEditorProps {
  data: Item;
  onCommit: (v: string) => void;
}

const TimeValueEditor = ({ data, onCommit }: TimeValueEditorProps) => {
  const displayTz = useDisplayTimezone();
  const dateValue = data.value ? strTimeAsNativeDate(data.value) : null;

  const handleChangeTime = (e: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
    const d = e.value as Date | null;
    if (!d) return;

    const newValue = formatTimeHHmm(toZonedDateTime(d, displayTz));

    if (newValue !== data.value) {
      onCommit(newValue);
    }
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <Calendar
        value={dateValue}
        onChange={handleChangeTime}
        placeholder={T("placeholder.time-not-set")}
        className="w-full"
        timeOnly
        stepMinute={1}
      />
    </div>
  );
};

export default TimeValueEditor;
